import React from "react";
import Stars from "../../global/Customreviews/Stars";



function Faq() {

    // const ReadMore = ({ children }) => {
    //     const text = children;
    //     const [isReadMore, setIsReadMore] = useState(true);
    //     const toggleReadMore = () => {
    //         setIsReadMore(!isReadMore);
    //     };
    //     return (
    //         <p className="text">
    //             {isReadMore ? text.slice(0, 100) : text}
    //             <span onClick={toggleReadMore} className="read-or-hide text-gray-400">
    //                 {isReadMore ? "...read more" : " show less"}
    //             </span>
    //         </p>
    //     );
    // };
    const moverReview = [
        {
            UserName: "Our Clients",
            Rate: 5,
            Description: "I know I tell you every time y’all come, but I hope you know how very much I appreciate you ladies! It’s so very nice to come home to a spotless house even if it doesn’t last long after everyone else gets home. THANK YOU! Y’all do a fantastic job every single time. I’ve been through so many cleaning people and they start out well and then the service gets not so great over time and I end up having to cancel the service. You all hit it out of the park EVERY SINGLE TIME! Kristi",
        },

    ]




    return (
        <section className="w-4/5 h-auto my-10 mx-auto gap-5 grid md:grid-cols-1 grid-cols-1">
            {
                moverReview.map((item, index) => {
                    return (
                        <article key={index} className="h-auto p-2 flex flex-col items-center justify-center rounded-3xl bg-gray-100 w-auto">
                            <div className="flex flex-col">
                                <div className="p-2 flex space-x-2">
                                    <div className="flex justify-center">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/imagenes-fc412.appspot.com/o/user.jfif?alt=media&token=2e7c59b5-a71c-4739-8260-bb88b37b08fa"
                                            alt="perfil-foto"
                                            className="w-[50px] h-auto rounded-full object-cover" />
                                    </div>
                                    <div>
                                        <span className="text-[20px] font-semibold"> {item?.UserName} </span>
                                        <Stars score={item?.Rate} />
                                    </div>
                                    <div className="flex items-end text-[13px] text-gray-400">
                                        <span>{item?.Date}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="p-5 ">
                                <p>{item?.Description}</p>
                            </div>
                            {/* <div className="w-full flex items-center space-x-3 ml-3">
                                <div className="w-[25px] h-[25px] flex items-center">
                                    <img src={item?.ima} alt="agni" className="w-full mx-auto" />
                                </div>
                                <div className="flex flex-col items-center justify-start">
                                    <p>Posted On</p>
                                    <a className="text-blue-500 w-full" href={item?.enlace}>{item?.red}</a>
                                </div>
                            </div> */}
                        </article>
                    );
                })
            }
        </section>
    );
}

export default Faq;